import { render, staticRenderFns } from "./RequestUser.vue?vue&type=template&id=ac621bac&scoped=true"
import script from "./RequestUser.vue?vue&type=script&lang=js"
export * from "./RequestUser.vue?vue&type=script&lang=js"
import style0 from "./RequestUser.vue?vue&type=style&index=0&id=ac621bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac621bac",
  null
  
)

export default component.exports